import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import React, { useRef, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Images } from "../../helpers/Images";
import emailjs from "@emailjs/browser";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { Gallery } from "../../helpers/gallery";

const ContactTemplate = () => {
  // const location = useLocation();
  // console.log();
  // const [state, setState] = useState({
  //   fname: "",
  //   lname: "",
  //   email: "",
  //   message: "",
  //   mailSent: false,
  //   error: null,
  // });
  // const API_PATH = `${window.location.origin}/API/index.php`;

  // const handleFormSubmit = (event) => {
  //   event.preventDefault();
  //   console.log(state);
  //   axios({
  //     method: "post",
  //     url: `${API_PATH}`,
  //     headers: { "content-type": "application/json" },
  //     data: state,
  //   })
  //     .then((result) => {
  //       setState({
  //         mailSent: result.data.sent,
  //       });
  //     })
  //     .catch((error) => setState({ error: error.message }));
  // };
  return (
    <>
      <Box
        sx={{
          width: "100%",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
          maxWidth: "1500px",
          margin: "auto",
        }}
      >
        {/* <form method="post" action="main.php">
          <label>First Name</label>
          <input
            type="text"
            id="fname"
            name="firstname"
            placeholder="Your name.."
            value={state?.fname}
            onChange={(e) => setState({ ...state, fname: e.target.value })}
          />
          <label>Last Name</label>
          <input
            type="text"
            id="lname"
            name="lastname"
            placeholder="Your last name.."
            value={state?.lname}
            onChange={(e) => setState({ ...state, lname: e.target.value })}
          />

          <label>Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Your email"
            value={state?.email}
            onChange={(e) => setState({ ...state, email: e.target.value })}
          />

          <label>Subject</label>
          <textarea
            id="subject"
            name="subject"
            placeholder="Write something.."
            value={state?.message}
            onChange={(e) => setState({ ...state, message: e.target.value })}
          ></textarea>
          <input
            type="submit"
            value="Submit"
            onClick={(e) => handleFormSubmit(e)}
          />
        </form>
        <div>{state?.mailSent && <div>Thank you for contacting us.</div>}</div> */}
        <Typography
          variant={"h1"}
          sx={{
            color: "primary.darker",
            fontSize: { xs: "28px", sm: "34px", md: "42px" },
            lineHeight: 1.15,
            fontWeight: 800,
            letterSpacing: "-0.02em",
            textAlign: { xs: "center" },
          }}
        >
          Get In Touch
        </Typography>
        <Box
          sx={{
            height: "4px",
            width: { xs: "80px", md: "120px" },
            borderRadius: "999px",
            background: "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
            margin: "10px auto 20px",
          }}
        />
        <Typography
          sx={{
            color: "primary.darker",
            lineHeight: 1.5,
            fontSize: { xs: "16px", md: "20px" },
            margin: "0 0 10px",
            textAlign: "center",
          }}
        >
          Want to get in touch? We'd love to hear from you. Here's how you can
          reach us..
        </Typography>
        <Grid container spacing={3} sx={{ marginTop: "10px" }}>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                position: "relative",
                minHeight: { xs: "220px", md: "260px" },
                borderRadius: "20px",
                overflow: "hidden",

                border: "1px solid rgba(255, 255, 255, 0.25)",
                boxShadow: "0 12px 32px rgba(0, 0, 0, 0.2)",
                transition: "transform 0.35s ease",
                "&:hover": { transform: "translateY(-6px)" },
                "&:hover .other-cat-image": {
                  transform: "scale(1.06)",
                },
              }}
            >
              <Box
                className="other-cat-image"
                sx={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `url(${Gallery.gallery15})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  transition: "transform 0.5s ease",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(10,14,24,0.5) 0%, rgba(10,14,24,0.85) 100%)",
                }}
              />
              <Box
                sx={{
                  position: "relative",
                  zIndex: 1,
                  height: "100%",
                  minHeight: { xs: "220px", md: "260px" },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  p: 2.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    color: "#23aef4",
                    mb: 0.5,
                  }}
                >
                  Get in touch
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "22px", md: "26px" },
                    fontWeight: 800,
                    lineHeight: 1.15,
                  }}
                >
                  Talk ?
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "14px",
                    mt: 0.5,
                    mb: 1.5,
                  }}
                >
                  Interested to participate in We Do Challenge this year? Just
                  pick up the phone to call a member of our team..
                </Typography>
                <a
                  href={"tel:+201044664265"}
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.75,
                      px: 1.75,
                      py: 1,
                      borderRadius: "999px",
                      backgroundColor: "#fff",
                      color: "#23aef4",
                      fontSize: "15px",
                      fontWeight: 700,
                      opacity: { xs: 1 },
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  >
                    Call Now
                  </Box>
                </a>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                position: "relative",
                minHeight: { xs: "220px", md: "260px" },
                borderRadius: "20px",
                overflow: "hidden",

                border: "1px solid rgba(255, 255, 255, 0.25)",
                boxShadow: "0 12px 32px rgba(0, 0, 0, 0.2)",
                transition: "transform 0.35s ease",
                "&:hover": { transform: "translateY(-6px)" },
                "&:hover .other-cat-image": {
                  transform: "scale(1.06)",
                },
              }}
            >
              <Box
                className="other-cat-image"
                sx={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `url(${Gallery.gallery2})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  transition: "transform 0.5s ease",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(10,14,24,0.1) 0%, rgba(10,14,24,0.85) 100%)",
                }}
              />
              <Box
                sx={{
                  position: "relative",
                  zIndex: 1,
                  height: "100%",
                  minHeight: { xs: "220px", md: "260px" },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  p: 2.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    color: "#23aef4",
                    mb: 0.5,
                  }}
                >
                  Get in touch
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "22px", md: "26px" },
                    fontWeight: 800,
                    lineHeight: 1.15,
                  }}
                >
                  Chat ?
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "14px",
                    mt: 0.5,
                    mb: 1.5,
                  }}
                >
                  Want some help? Have any question? Just click here to
                  immediately chat with us..
                </Typography>
                <a
                  target="_blank"
                  href="https://wa.me/+201044664265"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.75,
                      px: 1.75,
                      py: 1,
                      borderRadius: "999px",
                      backgroundColor: "#fff",
                      color: "#23aef4",
                      fontSize: "15px",
                      fontWeight: 700,
                      opacity: { xs: 1 },
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  >
                    Chat Now
                  </Box>
                </a>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                position: "relative",
                minHeight: { xs: "220px", md: "260px" },
                borderRadius: "20px",
                overflow: "hidden",

                border: "1px solid rgba(255, 255, 255, 0.25)",
                boxShadow: "0 12px 32px rgba(0, 0, 0, 0.2)",
                transition: "transform 0.35s ease",
                "&:hover": { transform: "translateY(-6px)" },
                "&:hover .other-cat-image": {
                  transform: "scale(1.06)",
                },
              }}
            >
              <Box
                className="other-cat-image"
                sx={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `url(${Images.gold})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  transition: "transform 0.5s ease",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(10,14,24,0.1) 0%, rgba(10,14,24,0.85) 100%)",
                }}
              />
              <Box
                sx={{
                  position: "relative",
                  zIndex: 1,
                  height: "100%",
                  minHeight: { xs: "220px", md: "260px" },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  p: 2.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    color: "#23aef4",
                    mb: 0.5,
                  }}
                >
                  Get in touch
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "22px", md: "26px" },
                    fontWeight: 800,
                    lineHeight: 1.15,
                  }}
                >
                  Any Inquiries ?
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "14px",
                    mt: 0.5,
                    mb: 1.5,
                  }}
                >
                  For any inquiries or to connect via email, please reach out to
                  us at: info@wedochallenge.org
                </Typography>
                <a
                  target="_blank"
                  href="mailto:info@wedochallenge.org"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.75,
                      px: 1.75,
                      py: 1,
                      borderRadius: "999px",
                      backgroundColor: "#fff",
                      color: "#23aef4",
                      fontSize: "13px",
                      fontWeight: 700,
                      opacity: { xs: 1 },
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  >
                    Send Email
                  </Box>
                </a>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box
              sx={{
                position: "relative",
                minHeight: { xs: "220px", md: "260px" },
                borderRadius: "20px",
                overflow: "hidden",

                border: "1px solid rgba(255, 255, 255, 0.25)",
                boxShadow: "0 12px 32px rgba(0, 0, 0, 0.2)",
                transition: "transform 0.35s ease",
                "&:hover": { transform: "translateY(-6px)" },
                "&:hover .other-cat-image": {
                  transform: "scale(1.06)",
                },
              }}
            >
              <Box
                className="other-cat-image"
                sx={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `url(${Gallery.gallery39})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  transition: "transform 0.5s ease",
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(180deg, rgba(10,14,24,0.1) 0%, rgba(10,14,24,0.85) 100%)",
                }}
              />
              <Box
                sx={{
                  position: "relative",
                  zIndex: 1,
                  height: "100%",
                  minHeight: { xs: "220px", md: "260px" },
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",
                  p: 2.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "11px",
                    fontWeight: 700,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                    color: "#23aef4",
                    mb: 0.5,
                  }}
                >
                  Get in touch
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: { xs: "22px", md: "26px" },
                    fontWeight: 800,
                    lineHeight: 1.15,
                  }}
                >
                  Join Our Community!
                </Typography>
                <Typography
                  sx={{
                    color: "rgba(255,255,255,0.8)",
                    fontSize: "14px",
                    mt: 0.5,
                    mb: 1.5,
                  }}
                >
                  All updates will be shared exclusively on our WhatsApp group.
                  Let's connect and grow together!
                </Typography>
                <a
                  target="_blank"
                  href="https://whatsapp.com/channel/0029VafuisvA89MZzeUs631Y"
                  style={{ textDecoration: "none" }}
                >
                  <Box
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.75,
                      px: 1.75,
                      py: 1,
                      borderRadius: "999px",
                      backgroundColor: "#fff",
                      color: "#23aef4",
                      fontSize: "13px",
                      fontWeight: 700,
                      opacity: { xs: 1 },
                      transition: "opacity 0.3s ease, transform 0.3s ease",
                    }}
                  >
                    Join now
                  </Box>
                </a>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <Box
        id={"questions"}
        sx={{
          width: "100%",
          padding: { xs: "50px 20px", sm: "50px 60px", lg: "50px 120px" },
          maxWidth: "1500px",
          margin: "auto",
        }}
      >
        <Typography
          variant={"h1"}
          sx={{
            color: "primary.darker",
            fontSize: { xs: "28px", sm: "34px", md: "42px" },
            lineHeight: 1.15,
            fontWeight: 800,
            letterSpacing: "-0.02em",
            textAlign: { xs: "center" },
          }}
        >
          Questions & Answers
        </Typography>
        <Box
          sx={{
            height: "4px",
            width: { xs: "80px", md: "120px" },
            borderRadius: "999px",
            background: "linear-gradient(90deg, #23aef4 0%, #c11a83 100%)",
            margin: "10px auto 20px",
          }}
        />
        <Box id={"questions"} sx={{ marginTop: "50px" }}>
          {[
            {
              question: "What is the We Do Challenge Championship?",
              answer:
                "The We Do Challenge Championship is a global competition designed to inspire young minds aged 4 to 10 years by introducing them to the exciting world of STEAM (Science, Technology, Engineering, Arts, and Mathematics).",
            },
            {
              question:
                "Who can participate in the We Do Challenge Championship?",
              answer:
                "The competition is open to children aged 4-10 years old.",
            },
            {
              question: "How does the competition work?",
              answer:
                "Each year, a unique global challenge is revealed. Teams are tasked with designing, building, and programming robots that will help address the problem presented.",
            },
            {
              question:
                "Is there a required tool kit to participate in the We Do Challenge?",
              answer:
                "No, participants can use various materials, such as LEGO kits or even handmade robots, to build their creations.",
            },
            {
              question: "What are the age requirements for participants?",
              answer:
                "The competition is divided into two age groups: We Do Researchers: for children aged 4 to 6 years old - We Do Engineers: for children aged 6 to 10 years old. Teams must consist of children within their respective age group, and each group will compete with others in the same category. This division allows participants to engage with challenges that are developmentally appropriate for their age and skills.",
            },

            {
              question: "Can participants work individually?",
              answer:
                "No, teams must have at least two participants. The We Do Challenge Championship emphasizes collaboration, and working as a team helps build essential skills like communication, teamwork, and creative problem-solving.",
            },
            {
              question:
                "What type of robots can teams build for the competition?",
              answer:
                "Teams are encouraged to build their robots using materials like LEGO kits, handmade parts, or any other available tools. The goal is to be creative and resourceful in developing solutions to the given challenge. Your robot should meet the competition's specifications and be able to perform tasks relevant to solving the problem.",
            },
            {
              question:
                "Are there any workshops or mentorship programs to help teams?",
              answer:
                "Yes, there are usually workshops, webinars, or mentorship programs available for participants. These programs are designed to help teams with the basics of robot design, programming, and project management, ensuring they are prepared",
            },
            {
              question: "Can we submit a project instead of a robot?",
              answer:
                "Yes, participants can also submit a project, this can include a working prototype, poster introduce their findings, or even a digital solution that demonstrates the team's approach to solve the challenge.",
            },
          ].map((item) => (
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography
                  sx={{
                    color: "primary.darker",
                  }}
                >
                  {item.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography
                  sx={{
                    color: "primary.darker",
                  }}
                >
                  {item.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default ContactTemplate;
